

export const apiSubTypes = [
  { key: 'All API' },
  { key: '/api/v1/account' },
  { key: '/api/v1/assetcollection' },
  { key: '/api/v1/assetcollection/{ID}' },
  { key: '/api/v1/assetcollection/{ID}/download' },
  { key: '/api/v1/assets/{ASSET_ID}/addons/face_recognition' },
  { key: '/api/v1/assets/addons/image_graphics/jobs/{JOB_ID}' },
  { key: '/api/v1/assets/{ASSET_ID}/addons/pose_classification/jobs/{JOB_ID}' },
  { key: '/api/v1/assets/{ASSET_ID}/addons/bg_remove' },
  { key: '/api/v1/assets/{ASSET_ID}/addons/print_export' },
  { key: '/api/v1/assets/ASSETS/addons/pose_classification/jobs/{JOB_ID}' },
  { key: '/api/v1/assets/{ASSET_ID}/addons/pose_classification' },
  { key: '/api/v1/assets/addons/collage' },
  { key: '/api/v1/assets/addons/face_recognition/delete' },
  { key: '/api/v1/authentication/service_token' },
  { key: '/api/v1/ml/people/facesearch' },
  { key: '/api/v1/assets/addons/image_graphics' },
  { key: '/api/v1/assets/search' },
  { key: '/api/v1/assets/addons/collage/jobs/{JOB_ID}' },
  { key: '/api/assets/{ASSET_ID}/content/{CONTENT_KEY}' },
  { key: '/api/v1/assetcollections' },
  { key: '/api/v1/assets/addons/advanced_collage' },
  { key: '/api/v1/assets/addons/advanced_collage/jobs/{JOB_ID}' },
  { key: '/api/v1/assets/addons/image_collage' },
  { key: '/api/v1/assets/file/addons/bg_remove' },
  { key: '/api/v1/assets/file/addons/image_autofix' },
  { key: '/api/v1/assets/file/addons/redeye_remove' },
  { key: '/api/v1/assets/get_link' },
  { key: '/api/v1/assets/new/content/original/external' },
  { key: '/api/v1/assets/new/content/{CONTENT_KEY}', value: '/api/v1/assets/new/content/original/upload (includes replace api)' },
  { key: '/api/v1/assets/new/content_storage_url' },
  { key: '/api/v1/assets/new/register_asset' },
  { key: '/api/v1/assets/trash/{ASSET_ID}/undelete' },
  { key: '/api/v1/assets/{ASSET_ID}/addons/emotion_recognition' },
  { key: '/api/v1/assets/{ASSET_ID}/addons/emotion_recognition/jobs/{JOB_ID}' },
  { key: '/api/v1/assets/{ASSET_ID}/addons/image_autofix' },
  { key: '/api/v1/assets/{ASSET_ID}/addons/redeye_remove' },
  { key: '/api/v1/assets/{ASSET_ID}/addons/scene_classification' },
  { key: '/api/v1/assets/{ASSET_ID}/addons/scene_classification/jobs/{JOB_ID}' },
  { key: '/api/v1/assets/{ASSET_ID}/clip/process' },
  { key: '/api/v1/assets/{ASSET_ID}/content/original/replace' },
  { key: '/api/v1/assets/{ASSET_ID}/content/remove_public_access' },
  { key: '/api/v1/assets/{ASSET_ID}/content/set_public_access' },
  { key: '/api/v1/assets/{ASSET_ID}/content/{CONTENT_KEY}' },
  { key: '/api/v1/assets/{ASSET_ID}/content/{CONTENT_KEY}/delete' },
  { key: '/api/v1/assets/{ASSET_ID}/conversions' },
  { key: '/api/v1/assets/{ASSET_ID}/conversions/{CONVERSION_KEY}' },
  { key: '/api/v1/assets/{ASSET_ID}/data' },
  { key: '/api/v1/assets/{ASSET_ID}/data/update' },
  { key: '/api/v1/assets/{ASSET_ID}/delete' },
  { key: '/api/v1/assets/{ASSET_ID}/get_link' },
  { key: '/api/v1/assets/{ASSET_ID}/process' },
  { key: '/api/v1/assets/{ASSET_ID}/storyboard/{CONTENT_KEY}' },
  { key: '/api/v1/assets/{ASSET_ID}/transcodes/{CONTENT_KEY}' },
  { key: '/api/v1/assetschema' },
  { key: '/api/v1/assetschemas' },
  { key: '/api/v1/cdn/prefetch' },
  { key: '/api/v1/clip/{ASSET_ID}' },
  { key: '/api/v1/data/{ASSET_ID}' },
  { key: '/api/v1/delete/{ASSET_ID}' },
  { key: '/api/v1/files/get_link/{ASSET_ID}' },
  { key: '/api/v1/jobs/{ID}' },
  { key: '/api/v1/ml/people/delete' },
  { key: '/api/v1/ml/people/update_metadata' },
  { key: '/api/v1/process/{ASSET_ID}' },
  { key: '/api/v1/replace/{ASSET_ID}' },
  { key: '/api/v1/reset_public_access/{ASSET_ID}' },
  { key: '/api/v1/schema' },
  { key: '/api/v1/schema/{ID}' },
  { key: '/api/v1/schemas' },
  { key: '/api/v1/set_public_access/{ASSET_ID}' },
  { key: '/api/v1/stats/api' },
  { key: '/api/v1/stats/cdn' },
  { key: '/api/v1/stats/timeseries/addons' },
  { key: '/api/v1/stats/timeseries/api' },
  { key: '/api/v1/stats/timeseries/cdn' },
  { key: '/api/v1/stats/timeseries/transcodes' },
  { key: '/api/v1/stats/{ID}' },
  { key: '/api/v1/stats/{ID}/{ID}' },
  { key: '/api/v1/undelete/{ASSET_ID}' },
  { key: '/api/v1/update/{ASSET_ID}' },
  { key: '/api/v1/upload' },
  { key: '/api/v1/user/settings' },
  { key: '/api/v1/users/{ID}' },
  { key: '/api/v1/users' },
  { key: '/api/v1/video/{ASSET_ID}/{CONTENT_KEY}' },
  { key: '/api/v1/zoomable/{ASSET_ID}/deepzoom_files/{ID}/{CONTENT_KEY}' },
  { key: '/api/v1/zoomable/{ASSET_ID}/{CONTENT_KEY}' },
];

export const cdnSubTypes = [
  {
    key: 'Traffic',
    value:'Traffic - Total data delivered from CDN'
  },
  {
    key: 'Request',
    value: 'Requests- Total number of requests made to CDN'
  },
];


export const storageSubTypes = [
  {
    key: 'ASSETS',
    value: 'Storage - Total storage used by assets'
  }
];

export const aiCreditSubTypes = [
  { key: 'AI_CREDITS_USED', value: 'Credits Used' },
];

export const aiRequestSubTypes = [
  { key: 'AI_REQUESTS', value: 'All Requests' },
];